import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scene-information-popover',
  templateUrl: './scene-information-popover.component.html',
  styleUrls: ['./scene-information-popover.component.scss'],
})
export class SceneInformationPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
